import { PROVIDERS_MAP } from 'common/constants/constants';

const ConnectJiraWrapper = ({ children }) => {
  return (
    <div className='mt-6 flex flex-col'>
      <div className='flex items-center pb-3'>
        <div className='flex items-center pb-3'></div>
        <img className='h-[1.8rem]' src={PROVIDERS_MAP.jira.logo} alt='' />
        <div className='ml-3 text-lg font-medium'>Connect Jira</div>
      </div>
      {children}
    </div>
  );
};

export default ConnectJiraWrapper;
